import React, { useEffect } from "react";
// import BrandArea from "../../components/BrandArea/BrandArea";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import ServicesAreaAll from "../../components/ServicesArea/ServicesAreaAll";
import Layout from "../../layouts/Layout";
import { gsapTitleAnimation } from "../../lib/gsap-lib/gsapTitleAnimation";

const ServicesPageTwo = () => {
  useEffect(() => {
    gsapTitleAnimation();
  }, []);

  return (
    <>
      <Layout header={1} footer={1}>
        <BreadcrumbArea
          title={"Handyman & Home Renovation Services in Kuala Lumpur, Selangor & Malaysia"}
          subtitle={"Our Services"}
        />
        <ServicesAreaAll />
        {/* <BrandArea className={"inner-brand-area pb-70"} /> */}
      </Layout>
    </>
  );
};

export default ServicesPageTwo;
